import React from "react";
import { GlobalBusinessAutoCompleteItem } from "components/Form/AutoCompleteBusinessPicker/types";
import { SmallText } from "components/Text";

interface OptionDescriptionProps {
  option: GlobalBusinessAutoCompleteItem;
}

const OptionDescription = ({
  option,
}: OptionDescriptionProps): React.JSX.Element => {
  const matchedItems: string[] = [];
  if (option.matched_fields.includes("name")) {
    matchedItems.push(`Name: ${option.name}`);
  }
  if (
    option.matched_fields.includes("trading_name") &&
    option.trading_name !== option.name
  ) {
    matchedItems.push(`Trading Name: ${option.trading_name}`);
  }
  if (option.matched_fields.includes("abn")) {
    matchedItems.push(`ABN: ${option.ABN}`);
  }

  // Maybe see if we can qualify this as which one matched?  That's just re-implementing a text search here, though...
  // One for a rainy day.
  if (option.matched_fields.includes("pics")) {
    if (option.PICs.length > 3) {
      matchedItems.push(`${option.PICs.length} PICs`);
    } else {
      matchedItems.push(`PICs: ${option.PICs.join(", ")}`);
    }
  }

  if (option.matched_fields.includes("business_users")) {
    // We don't show (or even receive) the actual business users attached.
    matchedItems.push("People");
  }

  if (option.matched_fields.includes("saleyards")) {
    if (option.saleyards_active.length > 3) {
      matchedItems.push(`${option.saleyards_active.length} Active Saleyards`);
    } else {
      matchedItems.push(`Saleyards: ${option.saleyards_active.join(", ")}`);
    }
  }

  return <>{matchedItems.join(" | ")}</>;
};
export const renderOptionWithMatches = (
  option: GlobalBusinessAutoCompleteItem,
): React.JSX.Element => (
  <div>
    {option.name}
    <br />
    <SmallText>
      <OptionDescription option={option} />
    </SmallText>
  </div>
);
